import { PageHeader } from "../components/PageHeader";
import { useSiteContent, resolveImageUrl } from "../context/ContentContext";
import { Link } from "react-router-dom";
import { ArrowRight, Check } from "lucide-react";
import { motion } from "framer-motion";

export default function Products() {
  const { content } = useSiteContent();
  const { products, images, products_page, products_specs } = content;
  const pageCopy = products_page || {};
  const specs = Array.isArray(products_specs) ? products_specs : [];
  return (
    <>
      <PageHeader
        eyebrow={pageCopy.header_eyebrow}
        title={
          <>
            {pageCopy.header_title_part1}{" "}
            <span className="theme-text-accent">{pageCopy.header_title_highlight}</span>
            {pageCopy.header_title_part2 ? ` ${pageCopy.header_title_part2}` : ""}
          </>
        }
        intro={pageCopy.header_intro}
      />

      <section className="section-pad">
        <div className="container-x grid grid-cols-1 sm:grid-cols-2 md:[grid-template-columns:repeat(auto-fit,minmax(240px,1fr))] gap-6">
          {products.map((p, i) => {
            const imgSrc = images[p.image] || p.image;
            return (
              <motion.div key={p.title || i} initial={{ opacity: 0, y: 24 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
                transition={{ duration: 0.6, delay: i * 0.05 }} className="card-soft overflow-hidden flex flex-col"
                data-testid={`product-${(p.title || "").toLowerCase().replace(/\s+/g, "-")}`}>
                <div className="aspect-[4/3] theme-bg-secondary overflow-hidden">
                  <img src={resolveImageUrl(imgSrc)} alt={p.title} className="w-full h-full object-cover" />
                </div>
                <div className="p-6 flex-1 flex flex-col">
                  <h3 className="font-display text-xl font-bold theme-text-primary">{p.title}</h3>
                  <p className="theme-text-muted text-sm mt-2 leading-relaxed">{p.desc}</p>
                  <ul className="mt-5 space-y-2 text-sm theme-text-secondary">
                    {(p.specs || []).map((s, idx) => (
                      <li key={idx} className="flex items-start gap-2"><Check className="w-4 h-4 theme-text-accent mt-0.5 shrink-0" /> {s}</li>
                    ))}
                  </ul>
                </div>
              </motion.div>
            );
          })}
        </div>
      </section>

      <section className="theme-bg-secondary section-pad">
        <div className="container-x">
          <div className="eyebrow mb-4">{pageCopy.specs_eyebrow}</div>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold theme-text-primary mb-10 sm:mb-12 tracking-tight">
            {pageCopy.specs_title}
          </h2>
          <div className="grid md:grid-cols-2 gap-5">
            {specs.map((s) => (
              <div key={s.label} className="theme-surface rounded-2xl p-6 flex flex-col sm:flex-row gap-3 sm:gap-5">
                <div className="text-[10px] tracking-[0.22em] theme-text-accent font-semibold mt-1 w-auto sm:w-32 shrink-0">{s.label.toUpperCase()}</div>
                <div className="theme-text-primary font-medium">{s.value}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="section-pad">
        <div className="container-x">
          <div className="rounded-3xl theme-gradient-dark p-7 sm:p-10 md:p-16 flex flex-col md:flex-row items-center justify-between gap-6">
            <div>
              <div className="eyebrow mb-3" style={{ color: "var(--gold-hover)" }}>{pageCopy.custom_eyebrow}</div>
              <h2 className="font-display text-2xl sm:text-3xl md:text-4xl font-bold max-w-2xl">
                {pageCopy.custom_title}
              </h2>
            </div>
            <Link to="/contact" className="btn-primary w-full sm:w-auto justify-center">
              {pageCopy.custom_button} <ArrowRight className="w-4 h-4" />
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
